import { render, staticRenderFns } from "./WEBNEWS.vue?vue&type=template&id=f42bd32e"
import script from "./WEBNEWS.vue?vue&type=script&lang=js"
export * from "./WEBNEWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports